import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Home from './layout/Home/Home.js';
import Produkt from './layout/Produkt/Produkt.js';
import ProduktSklep from './layout/ProduktSklep/ProduktSklep.js';
import Katalog from './layout/Katalog/Katalog.js';
import Lewa from './layout/Lewa/Lewa.js';
import Prawa from './layout/Prawa/Prawa.js';
import Gora from './layout/Gora/Gora.js';
import Login from './components/Login/Login.js';
import { getProducentStorage, GetProducent } from './dao/DAO.js';
import './App.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    useRouteMatch
} from "react-router-dom";
import Ustawienia from './layout/Ustawienia/Ustawienia.js';
// Since routes are regular React components, they
// may be rendered anywhere in the app, including in
// child elements.
//
// This helps when it's time to code-split your app
// into multiple bundles because code-splitting a
// React Router app is the same as code-splitting
// any other React app.

function setToken(userToken) {
    sessionStorage.setItem('token', JSON.stringify(userToken));
}
function getToken() {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
}

function getNIP() {
    let urlElements = window.location.pathname.split('/')
    console.log("window.location.pathname:" + window.location.pathname + " ele:" + urlElements[2]);
    const tokenString = sessionStorage.getItem('token');
    let userToken = JSON.parse(tokenString);
    console.log("userToken.nip" + userToken?.nip);
    if (urlElements[2] === "ustawienia") {
        userToken.nip = urlElements[3];
        sessionStorage.setItem('token', JSON.stringify(userToken));
    }

    return userToken?.nip;
}
function PoDodaniuProduktu() {
    const urlElements = window.location.pathname.split('/')
    console.log("window.location.pathname:" + window.location.pathname + " ele:" + urlElements[2]);
    if (urlElements[2] !== "produktpododniu") {
        console.log("urlElements[1]: " + urlElements[3]);
        return;
    }
    const id_produkt = urlElements[3];
    const nip = urlElements[4];
    const pr = getProducentStorage();

    if (pr.nip === nip) {
        window.location = process.env.PUBLIC_URL + "/produkt/" + id_produkt;
        return;
    }
    const spr = async () => {
        let datapr = await GetProducent(nip);
        console.log("producent login" + JSON.stringify(datapr));
        if ("error" in datapr) {
            console.log("error in" + datapr.error);
            window.location = process.env.PUBLIC_URL + "/start";
            return;
        }
        sessionStorage.setItem('producent', JSON.stringify(datapr.producent));
        window.location = process.env.PUBLIC_URL + "/produkt/" + id_produkt;
    }
    spr();

    return;
}
export default function App() {
    const token = getToken();
    if (!token) {
        return <Login setToken={setToken} />
    }

    PoDodaniuProduktu();


    const nip = getNIP();
    return (
        <Router basename={'/amarka'}>
            <Container fluid>
                <Row>
                    <Col className="menu-logo"><Gora /></Col>
                </Row>
                <Row>
                    <Col xl="1" className="wyglad p-0">
                        <Lewa nip={nip} />
                    </Col>
                    <Col className="wyglad scroll">
                        <Switch>
                            <Route exact path={'/start'}>
                                <Home />
                            </Route>
                            <Route path={'/katalog'}>
                                <KatalogRoute />
                            </Route>
                            <Route path={'/ustawienia'}>
                                <UstawieniaRoute />
                            </Route>
                            <Route path={'/produkt'}>
                                <ProduktRoute />
                            </Route>
                            <Route path={'/produktsklep'}>
                                <ProduktRouteSklep />
                            </Route>
                            <Route>
                                <Home />
                            </Route>
                        </Switch>
                    </Col>
                    <Col className="p-0 prawa" xl="1"><Prawa /></Col>
                </Row>
                <Row>
                    <Col className="stopka p-0 text-center">
                        <p>stopka</p>
                    </Col>
                </Row>
            </Container>
        </Router>
    );
}

function UstawieniaRoute() {
    let { path } = useRouteMatch();
    console.log("path" + path);
    return (
        <Switch>
            <Route path={`${path}/:nip`}>
                <Ustawienia />
            </Route>
        </Switch>
    );
}


function KatalogRoute() {
    let { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={path}>
                <Katalog />
            </Route>
            <Route path={`${path}/:str`}>
                <Katalog />
            </Route>
        </Switch>
    );
}
function ProduktRoute() {
    let { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path}>
                <h3>Please select a topic.</h3>
            </Route>
            <Route path={`${path}/:idprodukt`}>
                <Produkt />
            </Route>
        </Switch>
    );
}

function ProduktRouteSklep() {
    // The `path` lets us build <Route> paths that are
    // relative to the parent route, while the `url` lets
    // us build relative links.
    let { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path}>
                <h3>Please select a topic.</h3>
            </Route>
            <Route path={`${path}/:idprodukt`}>
                <ProduktSklep />
            </Route>
        </Switch>
    );
}
